export default () => {
    window.hideFieldsOnFormSuccess = hide;
    $('form[data-request-success-hide]').on('ajaxDone', (event, context, data) => {
        hide(event.currentTarget, data.result)
    })
}

function hide (form, message) {
    if (message) {
        $(form).find('.alert').text(message).fadeIn()
    }

    $(form).find('[data-hide-on-success], .hide-on-success').fadeOut({
        complete: () => {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(form).find('.alert').first().offset().top -
                    200,
            }, 0)
        },
    })
}
